export function commaSeparatedSymbols(raw: unknown): string | undefined {
  if (raw === undefined || raw === null) return undefined;
  if (Array.isArray(raw)) {
    const parts = raw
      .flatMap(p => String(p).split(','))
      .map(s => s.trim())
      .filter(s => s.length > 0);
    return parts.length > 0 ? parts.join(',') : undefined;
  }
  const s = String(raw).trim();
  return s || undefined;
}

export function commaSeparatedSymbolsDisplay(raw: unknown): string {
  const compact = commaSeparatedSymbols(raw);
  if (!compact) return '';
  return compact
    .split(',')
    .map(t => t.trim())
    .filter(Boolean)
    .join(', ');
}

export const CALENDAR_COMMA_LIST_KEYS = new Set(['tickers', 'securities', 'symbols']);

export function coerceSearchPropToString(search: unknown): string {
  if (typeof search === 'string') return search;
  if (Array.isArray(search)) return search.join(',');
  return String(search ?? '');
}
